/*
 * @Description:
 * @usage:
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-compoent-report-methods/banner-report.ts
 */
import { Ref } from 'vue';
import useGetCommonMethods from '@/composable/use-get-common-method';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import { EMiniAppPosition } from '@/constants/mini-app';
import { report } from '@/libs/report';
import { FeedReportOpt } from '@/types/feed';
import { ModelExposureMaterialInfo } from '@/types/model';
import { IS_SSR } from '@/utils/env';
import { useStore } from '@/store/index';

type Params = {
  btnTxt: Ref<string>,
  activeFeedReportOpt: Ref<FeedReportOpt>,
  exposureMaterialInfo: Ref<ModelExposureMaterialInfo>,
  isSupportExposureMaterial: Ref<boolean>
};

export default function useBannerReport(params: Params) {
  const { state } = useStore();
  const { btnTxt, activeFeedReportOpt, exposureMaterialInfo, isSupportExposureMaterial } = params;
  const { materialCategory, materialId } = exposureMaterialInfo.value ?? {};
  const { info: urlInfo } = useProvideUrlInfo();
  const { collectionid: collectionId } = urlInfo.query || {};

  const exposureMaterialReportOpt = {
    interact_mode_id: materialCategory === 'ws_interact_template' ? materialId : '',
    mode_id: materialCategory === 'videofunny' ? materialId : '',
    magic_id: materialCategory === 'camera' ? materialId : '',
    movie_id: materialCategory === 'recommend_template' ? materialId : '',
    h5material_id: materialCategory === 'h5_activity' ? materialId : '',
  };
  const { getMiniAppReportValue } = useGetCommonMethods();
  const mapBtnText2Status: Record<string, number> = {
    我也要拍: 1,
    立即去抢: 2,
    打开看看: 3,
  };
  const status = mapBtnText2Status[btnTxt.value] ?? 0;
  const bannerReport = {
    onClickBanner() {
      const { dramaList, activeIndex, isFullScreen, isDrama, isWsInstalled } = state;

      if (isSupportExposureMaterial.value) {
        report('cameratoo.bar.click', {
          ...activeFeedReportOpt.value,
          is_pull_pos: isWsInstalled ? 1 : 2,
          type: { ...exposureMaterialReportOpt, status },
        });
      } else {
        report('jump.weishi.click', {
          ...activeFeedReportOpt.value,
          is_pull_pos: isWsInstalled ? 1 : 2,
          type: {
            jump_miniApp: getMiniAppReportValue(EMiniAppPosition.open),
            collection_id: collectionId || '',
            micro_drama_id: isDrama ? dramaList[activeIndex]?.id || '' : '',
            play_status: isFullScreen ? 2 : 1,
            pull_pos: 1,
          },
        });
      }
    },
    onPopupExposure() {
      const { dramaList, activeIndex, isFullScreen, isDrama } = state;
      report('call.app.popup.exposure', {
        ...activeFeedReportOpt.value,
        type: {
          collection_id: collectionId || '',
          micro_drama_id: isDrama ? dramaList[activeIndex]?.id || '' : '',
          play_status: isFullScreen ? 2 : 1,
          clk_position: 'jump.weishi',
        },
      });
    },
    mountedReport() {
      if (IS_SSR) return;
      if (!isSupportExposureMaterial.value) {
        report('open.exposure', {
          ...activeFeedReportOpt.value,
          type: {
            jump_miniApp: getMiniAppReportValue(EMiniAppPosition.open),
          },
        });
      } else {
        report('cameratoo.bar.exposure', {
          ...activeFeedReportOpt.value,
          type: { ...exposureMaterialReportOpt, status },
        });
      }
    },
  };
  return bannerReport;
}
